var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-input',{attrs:{"value":_vm.time,"placeholder":"hh:mm","maxLength":5},on:{"change":_vm.onTimeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }